<template>
    <div class="border-top">
        <SOFilterTitle :title="getTitle" :diterapkan="diterapkan" :id="id" />
        <div class="p-l-24 p-r-24 p-d-24" v-show="false" :id="id">
            <SOFilterSelectSkeleton v-if="pageSetting.loading" />
            <SOInputSelect
                class="p-d-8"
                v-if="!pageSetting.loading"
                :title="''"
                :selected="filterItem.akunBiayaItemBiaya.idbiaya"
                :placeholder="'Pilih akun biaya'"
                :options="optionsBiaya"
                @option-selected="selectedBiaya"
            />
            <SOInputSelect
                v-if="!pageSetting.loading"
                :title="''"
                :selected="filterItem.akunBiayaItemBiaya.iditemBiaya"
                :placeholder="'Item biaya'"
                :options="optionsItemBiaya"
                @option-selected="selectedItemBiaya"
            />
        </div>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import SOFilterTitle from "@/so-components/global/filter/base/SOFilterTitle";
import SOFilterSelectSkeleton from "@/so-components/global/filter/skeleton/SOFilterSelectSkeleton";
import SOInputSelect from "@/so-components/global/input/SOInputSelect";

export default {
    name: "SOFilterAkunBiayaItemBiaya",
    components: {
        SOFilterTitle,
        SOFilterSelectSkeleton,
        SOInputSelect,
    },
    props: {
        id: String,
        title: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapGetters("filterGlobalModule", {
            filterItem: "getFilterItem",
        }),
        ...mapGetters("metaModule", {
            keuanganBiaya: "getListKeuanganBiaya",
            biayaItem: "getListBiayaItemKategori",
        }),
        getTitle() {
            return this.title;
        },
        idBiaya() {
            return this.filterItem.akunBiayaItemBiaya.idbiaya;
        },
        idBiayaItem() {
            return this.filterItem.akunBiayaItemBiaya.iditemBiaya;
        },
    },
    data() {
        return {
            pageSetting: {
                loading: true,
            },
            optionsBiaya: [],
            optionsItemBiaya: [],
            diterapkan: false,
        };
    },
    watch: {
        "filterItem.akunBiayaItemBiaya": {
            handler: function() {
                this.diterapkan = this.idBiaya && this.idBiayaItem ? true : false;
            },
            deep: true,
            immediate: true,
        },
    },
    mounted() {
        this.diterapkan = this.idBiaya && this.idBiayaItem ? true : false;
        this.getKeuanganBiaya();
    },

    methods: {
        async getKeuanganBiaya() {
            this.pageSetting.loading = true;
            const res = await this.$store.dispatch("metaModule/fetchListKeuanganBiaya");
            this.pageSetting.loading = false;
            if (res.success) {
                this.optionsBiaya = [];
                let i = 0;
                this.keuanganBiaya.forEach((kategori) => {
                    this.optionsBiaya = [
                        ...this.optionsBiaya,
                        {
                            id: kategori.idkategori,
                            text: kategori.nama_kategori,
                            children: [],
                        },
                    ];

                    kategori.keuangan_akun_akun.forEach((v) => {
                        this.optionsBiaya[i].children = [
                            ...this.optionsBiaya[i].children,
                            {
                                id: v.idakun,
                                text: v.nama_akun,
                            },
                        ];
                    });
                    i++;
                });

                if (this.idBiaya) {
                    this.getBiayaItem(this.idBiaya);
                }
            } else {
                this.$toast.error(res.err);
            }
        },
        async getBiayaItem(id) {
            const res = await this.$store.dispatch("metaModule/fetchListBiayaItemKategori", id);
            if (res.success) {
                this.optionsItemBiaya = [];
                this.biayaItem.forEach((kategori) => {
                    kategori.biaya_item.forEach((v) => {
                        this.optionsItemBiaya = [
                            ...this.optionsItemBiaya,
                            {
                                id: v.id,
                                text: v.nama,
                            },
                        ];
                    });
                });
            } else {
                this.$toast.error(res.err);
            }
        },
        selectedBiaya(val) {
            let temp = this.filterItem;
            temp.akunBiayaItemBiaya.idbiaya = val;
            temp.akunBiayaItemBiaya.iditemBiaya = "";
            this.$store.commit("filterGlobalModule/setFilterItem", temp);

            let { iditemBiaya, idbiaya } = this.filterItem.akunBiayaItemBiaya;

            this.diterapkan = idbiaya && iditemBiaya ? true : false;
            this.getBiayaItem(val);
        },
        selectedItemBiaya(val) {
            let temp = this.filterItem;
            temp.akunBiayaItemBiaya.iditemBiaya = val;
            this.$store.commit("filterGlobalModule/setFilterItem", temp);
            let { iditemBiaya, idbiaya } = this.filterItem.akunBiayaItemBiaya;

            this.diterapkan = idbiaya && iditemBiaya ? true : false;
        },
    },
};
</script>
